import { Search, X } from 'lucide-react';

/**
 * Standardised search bar:
 *  - Larger, more readable input (h-11)
 *  - Proper left padding (pl-11) so search icon doesn't overlap text
 *  - Clear (×) button when text is present
 *  - Sensible min-width so it always fits at least ~30 chars
 *
 * Props:
 *   value, onChange (string-based), placeholder, testId, className, minWidth
 */
export default function SearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  testId = 'search-input',
  className = '',
  minWidth = 'min-w-[260px]',
}) {
  return (
    <div className={`relative flex-1 ${minWidth} ${className}`}>
      <Search
        size={18}
        className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#4F734F] pointer-events-none"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        className="w-full h-11 pl-11 pr-10 bg-white border border-[#D5DFD5] rounded-sm text-sm text-[#111B11] placeholder:text-[#8AA08A] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-[#D4AF37] transition-shadow"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-[#F1F5F1] text-[#4F734F]"
          aria-label="Clear search"
          data-testid={`${testId}-clear`}
        >
          <X size={15} />
        </button>
      )}
    </div>
  );
}
